import {
	NEW_SLA_FORMAT,
	OLD_SLA_FORMAT,
} from '@atlassian/jira-servicedesk-sla-panel/src/common/constants';

export const NAME_FIELD = 'name';

/* metric default goal field names */
export const DEFAULT = 'default';

/* metric goal field names */
export const GOAL_FIELD_GROUP = 'goal-';
export const READ_ONLY = 'read-only-';
export const EDITABLE = 'editable-';
export const CALENDAR_FIELD_NAME = 'calendar-';
export const PRIORITY_FIELD_NAME = 'priority-';
export const DURATION_FIELD_NAME = 'duration-';
export const JQL_FIELD_NAME = 'jql-';
export const ROW_INDEX_TRACKER = `${GOAL_FIELD_GROUP}rowIndex-tracker-`;
export const DEFAULT_GOAL_ROW_INDEX_TRACKER = `${GOAL_FIELD_GROUP}non-draggable-rowIndex-tracker-`;
export const VALIDATE_GOAL_FIELD = 'validate-goal-';
export const EMPTY_JQL = 'Empty jql';
export const INVALID_JQL = 'Invalid jql';

/* field states */
export const NEW = 'new';
export const EXISTING = 'existing';
export const NEW_AND_MODIFIED = 'new-and-modified';
export const EXISTING_AND_MODIFIED = 'existing-and-modified';

/* goals limit states */
export const RESTING = 'resting';
export const ABOUT_TO_REACH_MAX = 'about-to-reach-max-goals';
export const MAX_REACHED = 'max-reached';
export const SHOW_WARNING_THRESHOLD = 5;

/* metric condition field names */
export const START_CONDITIONS_FIELD_NAME = 'start';
export const PAUSE_CONDITIONS_FIELD_NAME = 'pause';
export const STOP_CONDITIONS_FIELD_NAME = 'stop';

/* time picker errors */
export const EMPTY = 'Empty';
export const INVALID_DATE = 'Invalid Date';
export const EMPTY_TIME = 'Empty Time';
export const INVALID_TIME_RANGE = 'Invalid Time Range';

/* Calendar field names */
export const CALENDAR_NAME = 'calendarName';
export const TIMEZONE = 'timezone';

/* Calendar time picker field names */
export const TIME_PICKER_FIELD_PREFIX = 'connected-time-picker-';
export const TIME_PICKER_FIELD_START = '-start-';
export const TIME_PICKER_FIELD_END = '-end-';

/* Holiday field names */
export const HOLIDAY_PREFIX = 'holiday-field-group-';
export const HOLIDAY_NAME_PREFIX = 'holiday-name-';
export const HOLIDAY_DATE_PREFIX = 'holiday-date-';
export const HOLIDAY_FREQUENCY_PREFIX = 'holiday-frequency-';
export const HOLIDAY_VALIDATION_STATE_PREFIX = 'holiday-validation-state-';

/* Days enum */
export const DAYS_OF_THE_WEEK = [
	'monday',
	'tuesday',
	'wednesday',
	'thursday',
	'friday',
	'saturday',
	'sunday',
] as const;

export const DEFAULT_TIMEZONE = 'America/Toronto';

export const OnTrackOngoingSlaNewSlaFormat = {
	isBreached: false,
	timeRemainingInMinutes: 37,
	status: 'ONGOING',
	timeRemainingFriendly: 'Today 04:00 PM',
	metricName: 'Time to Pending',
	goalTime: '60m',
	calendarName: '24/7 Calendar (Default)',
	stopTime: 'Today 4:00 AM',
	previousCycles: [],
	hoverContent: '37m left • Due: 2022-03-21 04:00PM GMT+0530',
	slaDisplayFormat: 'NEW_SLA_FORMAT',
	breachTime: 1647858600000,
	remainingTimeMillis: '2220000',
	goalTimeMillis: '3600000',
	goalTimeLongFriendly: '60m',
	remainingTimeFriendly: '37m',
	isClosed: false,
	date: 1647858600000,
} as const;

export const OnTrackOngoingSlaOldSlaFormat = {
	isBreached: false,
	timeRemainingInMinutes: 300,
	status: 'ONGOING',
	timeRemainingFriendly: '7H 59M',
	metricName: 'Time to Pending',
	goalTime: '600m',
	calendarName: '24/7 Calendar (Default)',
	stopTime: 'Today 4:00 AM',
	previousCycles: [],
	hoverContent: undefined,
	slaDisplayFormat: OLD_SLA_FORMAT,
	breachTime: 1647858600000,
	remainingTimeMillis: '2220000',
	goalTimeMillis: '3600000',
	goalTimeLongFriendly: '60m',
	remainingTimeFriendly: '7h 59m',
	isClosed: false,
	date: 1647858600000,
} as const;

export const AtRiskOngoingSlaNewSlaFormat = {
	isBreached: true,
	timeRemainingInMinutes: -345,
	status: 'ONGOING',
	timeRemainingFriendly: 'Today 10:30 AM',
	metricName: 'Time to Pending',
	goalTime: '31m',
	calendarName: '24/7 Calendar (Default)',
	stopTime: 'Today 4:15 PM',
	previousCycles: [],
	hoverContent: '5h 45m past • Due: 2022-03-28 10:30AM GMT+0530',
	slaDisplayFormat: NEW_SLA_FORMAT,
	breachTime: 1648443600000,
	remainingTimeMillis: '-20700000',
	goalTimeMillis: '1860000',
	goalTimeLongFriendly: '31m',
	remainingTimeFriendly: '-5h 45m',
	isClosed: false,
	date: 1648443600000,
} as const;

export const AtRiskOngoingSlaOldSlaFormat = {
	isBreached: true,
	timeRemainingInMinutes: -1246,
	status: 'ONGOING',
	timeRemainingFriendly: '-20H 46m',
	metricName: 'Time to Pending',
	goalTime: '1531m',
	calendarName: '24/7 Calendar (Default)',
	stopTime: 'Today 4:15 PM',
	previousCycles: [],
	hoverContent: undefined,
	slaDisplayFormat: 'OLD_SLA_FORMAT',
	breachTime: 1648443600000,
	remainingTimeMillis: '2220000',
	goalTimeMillis: '3600000',
	goalTimeLongFriendly: '60m',
	remainingTimeFriendly: '7h 59m',
	isClosed: false,
	date: 1648443600000,
} as const;

export const CompletedSlaNewSlaFormat = {
	isBreached: false,
	timeRemainingInMinutes: 300,
	status: 'COMPLETED',
	timeRemainingFriendly: '24 February',
	metricName: 'Time to Pending',
	goalTime: '5h',
	calendarName: 'Test3',
	stopTime: '24/Feb/22 6:45 AM',
	previousCycles: [],
	hoverContent: '5h met • 0% of 5h • 2022-02-24 09:30PM GMT+0530',
	slaDisplayFormat: NEW_SLA_FORMAT,
	breachTime: 1645718400000,
	remainingTimeMillis: '18000000',
	goalTimeMillis: '18000000',
	goalTimeLongFriendly: '5h',
	remainingTimeFriendly: '5h',
	isClosed: true,
	date: 1648463400000,
} as const;

export const CompletedSlaOldSlaFormat = {
	isBreached: false,
	timeRemainingInMinutes: 300,
	status: 'COMPLETED',
	timeRemainingFriendly: '400H',
	metricName: 'Time to Pending',
	goalTime: '405h',
	calendarName: 'Test3',
	stopTime: '24/Feb/22 6:45 AM',
	previousCycles: [],
	hoverContent: undefined,
	slaDisplayFormat: OLD_SLA_FORMAT,
	breachTime: 1645718400000,
	remainingTimeMillis: '2220000',
	goalTimeMillis: '3600000',
	goalTimeLongFriendly: '60m',
	remainingTimeFriendly: '7h 59m',
	isClosed: true,
	date: 1648463400000,
} as const;
